export const HOME_CRUMB = 'HOME';

export const COMPANIES_CRUMB = '企業を探す';

export const COMPANY_FOLLOW_RANKING_CRUMB = 'フォロー数ランキング';

export const RECRUITING_INFO_CRUMB = '募集を探す';

export const REPORTS_CRUMB = 'ES・体験記';

export const COLUMN_CRUMB = 'コラム';
